import { Outlet, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function AppLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, [location.pathname]);
  const hideFooter =
    location.pathname.startsWith("/kyc") ||
    location.pathname.startsWith("/application");
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </>
  );
}
